import { defineMessages } from 'react-intl';

const lineMessages = defineMessages({
    lineLength: {
        id: 'line-length-unit-meter',
        defaultMessage: '{value} m.',
    },
});

export default lineMessages;
